<template>
    <div>
        <base-loading :visible="isLoading" />
        <edit-emails :item="item" v-model="modal" :title="$t('emails') | capitalize" @save="onSave" />
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <clients-table :items="items" @loadMore="loadMore" @edit="onEdit" @changeStatus="onChangeStatus"
                    @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifier } from '@/composables/useNotifier.js'
import { useNotificationExpense } from '../../composables/useNotificationExpense.js'
import ClientsTable from './components/ClientsTable.vue'
import BaseLoading from '@/views/app/components/BaseLoading.vue'
import SearchInput from '@/views/app/components/SearchInput.vue'
import EditEmails from './components/EditEmails.vue'

const { notify } = useNotifier()
const search = ref('')
const clients = useNotificationExpense()
const item = ref({})
const modal = ref(false)
const sort = ref({})

const items = computed(() => clients.state.items)
const currentPage = computed(() => clients.state.currentPage)
const lastPage = computed(() => clients.state.lastPage)
const isLoading = computed(() => clients.state.loading)

const loadData = async (params = {}) => {
    const payload = {
        page: clients.state.currentPage || 1,
        search: search.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    }
    const result = await clients.getClients(payload)
    if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = clients.state.currentPage + 1
    await loadData({ page: newPage })
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value })
}

const onEdit = async (row) => {
    const emails = [...row.emails]
    item.value = { clientId: row.ClientId, emails: emails }
    modal.value = true
}
const onSave = async (item) => {
    const payload = { clientId: item.clientId, emails: [...item.emails] }
    const result = await clients.updateEmails(payload)
    modal.value = false

    if (!result.success) {
        notify({ title: 'attention', text: 'message_error', color: 'warning' })
        return
    }

    const clientIndex = clients.state.items.findIndex(c => c.ClientId === item.clientId)
    if (clientIndex !== -1) {
        clients.state.items[clientIndex].emails = [...payload.emails]
    }

    notify({ title: 'success', text: 'message_update', color: 'success' })
}

const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key
    sort.value.order = sortData.order
    await loadData({ column: sort.value.column, order: sort.value.order })
}

const onChangeStatus = async ({ item, status }) => {
    const payload = { clientId: item.ClientId, status: status }
    const result = await clients.changeStatus(payload)
    if (!result.success) {
        notify({ title: 'attention', text: 'message_error', color: 'warning' })
        return
    }
    const clientIndex = clients.state.items.findIndex(c => c.ClientId === item.ClientId)
    if (clientIndex !== -1) {
        clients.state.items[clientIndex].active = status ? '1' : '0'
    }
    notify({ title: 'success', text: 'message_update', color: 'success' })
}

onMounted(() => loadData())

</script>
